const LeadingAtIntersection = () => {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-4 text-accent">
          Leading at the Intersection
        </h2>
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12 sm:mb-16 text-accent">
          of Digital Assets and Accounting
        </h3>

        {/* Visual showcase */}
        <div className="mb-12 sm:mb-16 max-w-5xl mx-auto">
          <img src="/3.png" alt="Digital Assets and Accounting" className="w-full h-auto rounded-2xl shadow-2xl" />
        </div>

        <div className="grid md:grid-cols-3 gap-12 md:gap-8 max-w-6xl mx-auto">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-accent rounded-2xl flex items-center justify-center">
              <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">
              First-Ever Real-Time Attestation by a CPA
            </h3>
            <p className="text-gray-700">
              The The Audit Financier Team team built the first-ever real-time attestation reporting system, first deployed in 2019. Today
              our transparency services cover Billions in USD value.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-accent rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 001.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 000 2h.013a9.358 9.358 0 000 1H6a1 1 0 100 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 10-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 01-.264-.521H10a1 1 0 100-2H8.017a7.36 7.36 0 010-1H10a1 1 0 100-2H8.472c.08-.185.167-.36.264-.521z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">
              From Stablecoins to RWAs
            </h3>
            <p className="text-gray-700">
              As tokenization evolves from simple stablecoins to more complex instruments like tokenized securities and
              RWAs, The Audit Financier Team is at the forefront of transparency.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-accent rounded-2xl flex items-center justify-center transform rotate-45">
              <div className="transform -rotate-45">
                <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">
              From Policy to Practice
            </h3>
            <p className="text-gray-700">
              In conjunction with industry experts, The Audit Financier Team co-authored The Digital Chamber's{' '}
              <span className="text-accent underline italic">"Practitioner's Guide to Proof of Reserves"</span>, the most
              comprehensive guide on PoR.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadingAtIntersection;
